/**
 * @ngdoc directive
 * @name phoenix.directive:pxAutocompleteClearOnBlur
 * @module phoenix
 * @restrict A
 * @description
 *
 * A directive to auto clear the autocomplete input if no item is selected 
 *
 * @usage
 *
 * <md-chips px-autocomplete-clear-on-blur />
 *
 */
export function AutocompleteClearOnBlurDirective(
	$interval:ng.IIntervalService, 
	$timeout:ng.ITimeoutService
) {
	return {
		restrict: 'A',
		require: 'mdAutocomplete',
		link: function (scope, element, attrs, acCtrl) {
			if (!acCtrl || acCtrl.readonly) { return; }

			// amount of time in MS with which to poll for an input
			var pollingThreshold = 6000; 
			var trigger = null;
			var start = Date.now();
			var timedOut = false;
			var input = null;
			var interval = $interval(function () {
				timedOut = (Date.now() - start) >= pollingThreshold;
				input = element.find('input');

				if (input.length === 1) {
					$interval.cancel(interval);
					input[0].addEventListener('blur', triggerRemove);
				}
				else if (timedOut) {
					$interval.cancel(interval);	
				}
			}, 100);

			function triggerRemove() {
				//timeout to allow user to pick from autocomplete
				$timeout(removeValue, 200);
			}

			function removeValue() {
				$timeout.cancel(trigger);
				//clear the value
				if (input.val() !== '' && !acCtrl.scope.selectedItem) {
					//clear search text
					acCtrl.scope.searchText = null;
				}
			}

			scope.$on('$destroy', function () {
				if(input.length > 0) {
					input[0].removeEventListener('blur', removeValue);
				}
			});
		}
	};
}

AutocompleteClearOnBlurDirective.$inject = [
	'$interval', 
	'$timeout'
];





// WEBPACK FOOTER //
// ./src/phoenix/components/autocompleteClearOnBlur/autocompleteClearOnBlur.ts